export const stripeId = 'pk_test_51Jjc2KINwaD3oHwN5IktU5cJuWROVS7yjMcfoW09EAmrdBsNjmZfr5WLEfNiDsFNV37muWb71xtxWd9BFL7g0iKs00yCpsVrt4';
